import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import {
  Column,
  DataGrid,
  FilterRow,
  HeaderFilter,
  Scrolling,
  Grouping,
  Editing,
  Lookup,
} from 'devextreme-react/data-grid';

import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';

import { useControlContent } from '../../../hooks/controlContent';

import ControlList from '../ControlList';
import GridLoader from '../../../components/GridLoader';

import { Board, BoardContent, BoardHeader } from '../../../components/Board';

import api from '../../../services/api';

export default function SellValueTypeAdmin() {
  const [dataSource, setDataSource] = useState<DataSource>({} as DataSource);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  const { setControlContent, setPageTitle } = useControlContent();

  useEffect(() => {
    setPageTitle('Finance');
    setControlContent(<ControlList />);

    // Load categories for lookup column
    api.get('scheduling/sell-value-types-categories').then(response => {
      setCategories(response.data);
    });

    const sellValueTypeStore = new CustomStore({
      key: 'ID',
      loadMode: 'raw',
      load: async () => {
        try {
          setLoading(true);
          const response = await api.get('scheduling/sell-value-types');
          setLoading(false);
          return response.data;
        } catch (err) {
          setLoading(false);
          console.error('Error loading sell-value-types', err);
          return [];
        }
      },
      update: async (key, values) => {
        try {
          const { data } = await api.put(
            `scheduling/sell-value-types/${key}`,
            values,
          );
          return data;
        } catch (err) {
          console.error('Error updating sell-value-type', err);
          throw err;
        }
      },
    });

    const sellValueTypeDataSource = new DataSource({
      store: sellValueTypeStore,
      paginate: true,
      reshapeOnPush: true,
    });

    setDataSource(sellValueTypeDataSource);
  }, [setControlContent, setPageTitle]);

  return (
    <Board>
      <BoardHeader
        title="Sell Value Types"
        description="Manage sell value types and their active status"
      />

      <BoardContent style={{ padding: 0, margin: 0, position: 'relative' }}>
        {loading && (
          <GridLoader>
            <CircularProgress color="primary" />
          </GridLoader>
        )}

        <DataGrid
          dataSource={dataSource}
          showBorders={false}
          remoteOperations={false}
          height="100%"
        >
          <FilterRow visible />
          <HeaderFilter visible />
          <Scrolling mode="infinite" />
          <Grouping autoExpandAll={false} />

          <Editing
            mode="batch"
            allowUpdating
            allowDeleting={false}
            allowAdding={false}
            texts={{
              saveAllChanges: 'Save changes',
              cancelAllChanges: 'Cancel changes',
            }}
          />

          <Column dataField="ID" visible={false} />
          <Column dataField="Description" caption="Description" allowEditing={false} />
          <Column
            dataField="Category.ID"
            caption="Category"
            allowEditing={false}
          >
            <Lookup
              dataSource={categories}
              valueExpr="ID"
              displayExpr="Description"
            />
          </Column>
          <Column dataField="ImpactProjectValue" dataType="boolean" caption="Impact Project Value" allowEditing={false} />
          <Column dataField="IsActive" dataType="boolean" caption="Active?" />
        </DataGrid>
      </BoardContent>
    </Board>
  );
}
